import React, { useState } from 'react';
import { Box, Button, Card, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Grid, InputLabel, Slide, Typography } from "@mui/material";
import * as yup from "yup";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup/dist/yup";
import { Organisations } from '../../../../../api/Endpoints/Organisation';
import SelectX from '../../../../form/SelectX'
import TextInput from '../../../../form/TextInput'
import DateInput from '../../../../form/DateInput'
import { Departments } from '../../../../../api/Endpoints/Departments';
import { Employee } from '../../../../../api/Endpoints/Employee';
import { LoadingButton } from "@mui/lab";
import toast from "react-hot-toast";
import { ErrorMessage } from "@hookform/error-message";
import AddIcon from "@mui/icons-material/Add";
import { useEffect } from 'react';
import moment from 'moment';
import ReactSelector from 'react-select';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});



const scheme = yup.object().shape({
    name: yup.string().required("field is requried"),
    email: yup.string().email().required("field is requried"),
    phone_number: yup.string().required("field is requried"),
    employee_roles_id: yup.object().required("field is requried"),
    departments_id: yup.object().required("field is requried"),
    address: yup.string().required("field is requried"),
    emergency_contacts: yup.string(),
    joining_date: yup.date().required("field is requried"),
    remarks: yup.string(),
});


const Salary = (props) => {
    const { register, handleSubmit, watch, formState: { errors }, control, setValue, getValues, reset } = useForm({ resolver: yupResolver(scheme), criteriaMode: "all" });

    const [loading, setLoading] = useState(false)


    const [formButtonStatus, setFormButtonStatus] = useState({
        label: "Submit",
        loading: false,
        disabled: false,
    });


    const fetchDepartments = (e) => {
        return Departments.get({ keyword: e }).then(response => {
            if (typeof response.data.data.data !== "undefined") {
                return response.data.data.data;
            } else {
                return [];
            }
        })
    }

    const fetchEmployeeRoles = (e) => {
        return Employee.getRoles({ keyword: e }).then(response => {
            if (typeof response.data.data.data !== "undefined") {
                return response.data.data.data;
            } else {
                return [];
            }
        })
    }


    const Status = [
        { value: "Trainee", label: 'Trainee' },
        { value: "Intern", label: 'Intern' },
        { value: "Executive", label: 'Executive' },
        { value: "Manager", label: 'Manager' },
        { value: "Senior Executive", label: 'Senior Executive' },
        { value: "Director", label: 'Director' }


    ];
    const EmployeeTy = [
        { value: "Consultant", label: 'Consultant' },
        { value: "Employee", label: 'Employee' },
        { value: "Ex-Employee", label: 'Ex-Employee' },

    ]
    const onSubmit = (data) => {
        setFormButtonStatus({ ...formButtonStatus, loading: true });
        console.log("this is data", data);
        let JoinDate = moment(data.joining_date).format('YYYY-MM-DD');
        let dataToSubmit = {
            id: props?.editId,
            users_id: props?.editId,
            parant_organisations_id: data?.parant_organisations_id?.id,
            name: data.name,
            email: data.email,
            phone_number: data.phone_number,
            departments_id: data.departments_id.id,
            employee_roles_id: data.employee_roles_id.id,
            address: data.address,
            emergency_contacts: data.emergency_contacts,
            joining_date: JoinDate,
            remarks: data.remarks,
        };


        let action;
        if (props.editId > 0) {

            action = Employee.update(dataToSubmit);
        } else {
            console.log("this si datatosubmit", dataToSubmit);
            action = Employee.add(dataToSubmit);

        }

        action.then(response => {
            setFormButtonStatus({ label: "Submitted", loading: false, disabled: true });
            setFormButtonStatus({ label: "Create", loading: false, disabled: false });
            if (response.data.errors) {
                toast.error("The email or phone number has already been taken")
                return
            }
            toast.success(response.data.message)
            props.onUpdate();
            // setOpen(false)
        }).catch(errors => {
            toast.error("Internal server error");
            setFormButtonStatus({ label: "Create", loading: false, disabled: false });
            // setOpen(false)
        })
    }



    useEffect(() => {
        if (parseInt(props.editId) > 0) {
            fetchDetails()
        }
    }, [props.editId])


    const fetchDetails = async () => {
        setLoading(true)
        let EmployeeDetail = await Employee.getEmployeeDetails({ id: props.editId });
        if (EmployeeDetail.data.status === "success") {
            let data = EmployeeDetail.data.data;
            setValue('name', data.user.name);
            setValue('email', data.user.email);
            setValue('phone_number', data.phone_number);
            setValue('departments_id', data.department);
            setValue('employee_roles_id', data.role);
            setValue('address', data.address);
            setValue('emergency_contacts', data.emergency_contacts);
            setValue('joining_date', data.joining_date);
            setValue('remarks', data.remarks);
        }
        setLoading(false)

    }


    return (
        <div>
            {/* <Button variant="contained" onClick={handleClickOpen} sx={{ mt: 2 }}>
                {props.icon ? <AddIcon style={{
                    display: 'flex',
                    alignItems: 'center',
                    flexWrap: 'wrap',
                }} /> : "Create Employee"}
            </Button> */}


            {/* <DialogTitle > {parseInt(props.editId) > 0 ? "Edit Employee" : "Create Employee"}</DialogTitle> */}

            {loading ? (
                <Box sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    width: '100%',
                    height: '30vh'
                }}>
                    <CircularProgress />
                </Box >
            ) : (
                <>


                    <Grid  >
                        <Grid item xs={12} sm={12}>
                            <form onSubmit={handleSubmit(onSubmit)}>
                                <Grid >
                                    <Grid container spacing={1}>
                                        <Grid item xs={6}>
                                            <TextInput
                                                control={control}
                                                name="basic_salary"
                                                label="Basic Salary"
                                                value={watch('basic_salary')}
                                            />
                                        </Grid>
                                        <Grid item xs={6}>
                                            <TextInput control={control} name="tds_percentage"
                                                label="TDS Percentage"
                                                value={watch('tds_percentage')} />
                                        </Grid>
                                    </Grid>

                                    <Grid container spacing={1} mt={2}>
                                        <Grid item xs={6}>
                                            <TextInput control={control} name="esi_employee"
                                                label="ESI Employee Share"
                                                value={watch('esi_employee')} />
                                        </Grid>
                                        <Grid item xs={6}>
                                            <TextInput
                                                control={control}
                                                name="ESI Employer Share"
                                                label="ESI Employer Share"
                                                value={watch('esi_employer_share')}
                                            />
                                        </Grid>
                                    </Grid>
                                    <Grid container spacing={1} mt={2}>
                                        <Grid item xs={6}>
                                            <TextInput control={control} name="pf_employee"
                                                label="PF Employee Share"
                                                value={watch('pf_employee')} />
                                        </Grid>
                                        <Grid item xs={6}>
                                            <TextInput
                                                control={control}
                                                name="PF Employer Share"
                                                label="PF Employer Share"
                                                value={watch('esi_employer_share')}
                                            />
                                        </Grid>
                                    </Grid>
                                    <Grid container spacing={1} mt={2}>
                                        <Grid item xs={6}>
                                            <TextInput control={control} name="hra"
                                                label="HRA"
                                                value={watch('hra')} />
                                        </Grid>
                                        <Grid item xs={6}>
                                            <TextInput
                                                control={control}
                                                name="travel_allowance"
                                                label="Travel Allowance"
                                                value={watch('travel_allowance')}
                                            />
                                        </Grid>
                                        <Grid item xs={6}>
                                            <TextInput
                                                control={control}
                                                name="other_allowance"
                                                label="Other Allowance"
                                                value={watch('other_allowance')}
                                            />
                                        </Grid>
                                    </Grid>

                                    <Grid item xs={12} mt={2}>
                                        <ErrorMessage
                                            errors={errors}
                                            name="multipleErrorInput"
                                            render={({ messages }) =>
                                                messages &&
                                                Object.entries(messages).map(([type, message]) => (
                                                    <p key={type}>{message}</p>
                                                ))
                                            }
                                        />
                                        <LoadingButton loading={formButtonStatus.loading} disabled={formButtonStatus.disabled}
                                            variant="outlined" type="submit">{formButtonStatus.label}</LoadingButton>
                                    </Grid>
                                </Grid>
                            </form>
                        </Grid>


                    </Grid>



                </>
            )}

        </div >
    );
};

export default Salary;
